import { render, staticRenderFns } from "./OrderOverviewProductDataArtworks.vue?vue&type=template&id=39884b3e&scoped=true"
import script from "./OrderOverviewProductDataArtworks.vue?vue&type=script&lang=ts"
export * from "./OrderOverviewProductDataArtworks.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./OrderOverviewProductDataArtworks.vue?vue&type=style&index=0&id=39884b3e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "39884b3e",
  null
  ,true
)

export default component.exports